import { Route } from '@angular/router';

import { adminGuard, authGuard } from '@instaclause-webapp/shared-core';

import { ForgotPasswordComponent } from './layout/forgot-password/forgot-password.component';
import { LoginComponent } from './layout/login/login.component';
import { MainLayoutComponent } from './layout/main/main-layout.component';
import { ResetPasswordComponent } from './layout/reset-password/reset-password.component';


export const appRoutes: Route[] = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [ authGuard ],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'contracts',
      },
      {
        path: 'contracts',
        loadChildren: () => import('./feature/contract/contract.routes'),
      },
      {
        path: 'help',
        loadChildren: () => import('./feature/help/help.routes'),
      },
      {
        path: 'settings',
        canActivate: [ adminGuard ],
        loadChildren: () => import('./feature/settings/settings.routes'),
      },
      {
        path: 'customers',
        loadChildren: () => import('./feature/customers/customers.routes'),
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
];
